/**
 * 座位状态枚举
 *
 * 是否占用由 SeatAssignment 绑定派生，此处仅表示座位本身的可用性状态。
 * RESERVED / DISABLED 为 P2 扩展。
 */
export enum SeatStatus {
  /** 可用（默认；是否占用由 SeatAssignment 派生） */
  AVAILABLE = 'AVAILABLE',
  /** 预留（P2 扩展） */
  RESERVED = 'RESERVED',
  /** 禁用（P2 扩展） */
  DISABLED = 'DISABLED',
}

/** 所有状态值的数组 */
export const SeatStatusValues: string[] = Object.values(SeatStatus);

/** 状态中文标签映射 */
export const SeatStatusLabels: Record<SeatStatus, string> = {
  [SeatStatus.AVAILABLE]: '可用',
  [SeatStatus.RESERVED]: '预留',
  [SeatStatus.DISABLED]: '禁用',
};
